import {Events, Config, Classes} from '../models';
import {isTouch, aspectRatio, getTopLeftOfElement, colorHelper} from '../helpers';

import PIXI from 'pixi.js/bin/pixi.min.js';
// this is buggy:
// import Pixi from 'pixi.js';

import TwistFilter from './filters/twistFilter';
import BulgeFilter from './filters/bulgeFilter';
import WaveFilter from './filters/WaveFilter';

import ecdFilter from './filters/ecdFilter';

import waveJson from './wave';

// import imgA from './filters/noise/waves.jpg';
// import DisplacementFilter from './filters/CustomDisplacementFilter';

var waves = function(obj) {
	// variables, accessible anywhere in private and public functions
	// do not need to use this.[var name]
	var el,
		showPoints = false,
		pointSize = 10,
		squareAlpha = 0.2,
		renderer,
		stage,
		container,
		gui,
		waves = [],
		waveContainers = [],
		waveFilters = [],
		twistFilters = [],

		prevX = 0,
		prevY = 0,
		// dynamically set by number of Wave Positions.
		numWaves = null,

		// wave positions:
		// array ->
		// [ wave ]
		// 		[ max or min range points]	
		//			{object list either points or curves depending on the num of keys}

		wavesPos = waveJson,

		// defines all the color steps using this.
		colorGroups = [
			[
				"#f274a0",
				"#a1c3d1"
			],

			[
				"#4f3850",
				"#f172a1"
			],
			[
				"#b39bc8",
				"#ad2e95"
			],
			[
				"#e64398",
				"#b39bc8"
			],
			[
				"#ad2e95",
				"#e64398"
			],
			[
				"#4f3850",
				"#a1c3d1"
			],
			[
				"#ed3da4",
				"#ad2e95"
			]
		],
		colorStepsProgress = 0,
		colorStepsMax = 200,
		colorStepsDirection = 0.25,
		// takes above array and generates steps.
		colorSteps = [];

	function init() {
		trace(' --- init waves ---');
		// assign
		el = obj.el;
		gui = document.querySelector('.gui');

		window.PIXI = PIXI;
		renderer = PIXI.autoDetectRenderer(Config.w.w, Config.w.h, {'transparent':true, 'antialias':true} );
		//renderer = PIXI.autoDetectRenderer(Config.w.w, Config.w.h, {'transparent':true} );
        el.appendChild(renderer.view);


        var gl = renderer.gl;
	  	
		// gl.disable(gl.BLEND);
		
		// gl.blendFunc(gl.ONE, gl.ZERO);
		// gl.enable(gl.DEPTH_TEST);
		
		// gl.enable(gl.BLEND);
		// gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);


		// gl.enable(gl.GL_BLEND);
		gl.blendFunc(gl.GL_SRC_ALPHA, gl.GL_ONE_MINUS_SRC_ALPHA);
	  	gl.blendEquation(gl.FUNC_ADD);


        // Stage
        stage = new PIXI.Stage(0xFF0000, true);

		// Container
        container = new PIXI.Container();
        
        stage.addChild(container);

        stage.interactive = true;

        numWaves = wavesPos.length;

        for( var c = 0; c < colorGroups.length; c++){
        	var gradientList = gradient(colorGroups[c][0], colorGroups[c][1], colorStepsMax );
        	colorSteps.push(gradientList);
        }

        createLayers();

        _redraw();
	}

	function createLayers() {
		// var sprite = new PIXI.Sprite.fromImage(imgA);
		var cbackground = new PIXI.Graphics();
		cbackground.beginFill(0xDDDDDD);
		cbackground.moveTo(0,0);
		cbackground.lineTo(0,Config.w.h);
		cbackground.lineTo(Config.w.w,Config.w.h);
		cbackground.lineTo(Config.w.w,0);

		container.addChild(cbackground);

		// start from top down to bottom.
		for( var l = 0; l < numWaves; l++){
			var waveContainer = new PIXI.Container();
			var wave = new PIXI.Graphics();
			var background = new PIXI.Graphics();

			background.beginFill( 0x333333 );
			
			background.moveTo(0,0);
			background.lineTo(0,Config.w.h);
			background.lineTo(Config.w.w,Config.w.h);
			background.lineTo(Config.w.w,0);

			background.alpha = 0.0;


			var c = l;
			if( c >= colorSteps.length ){
				c = l - colorSteps.length;
			}
			var colorGroup = colorSteps[c];


			waveContainer.width = Config.w.w;
			waveContainer.height = Config.w.h;

			waveContainer.filterArea = new PIXI.Rectangle(0, 0, Config.w.w, Config.w.h);
			// wave.filterArea = new PIXI.Rectangle(0, 0, Config.w.w, Config.w.h);

			var uniformColorA = colorHelper.hexToUniforms(colorGroup[0]);
			var uniformColorB = colorHelper.hexToUniforms(colorGroup[1]);

			var filter = new ecdFilter({});
			
			var twistFilter = new BulgeFilter();

			// add it the stage so we see it on our screens..
			// waveContainer.addChild(background);
			waveContainer.addChild(wave);

			var waveTexture = waveContainer.generateTexture(renderer);
    		var waveSprite = new PIXI.Sprite(waveTexture);
    		
			waveContainer.filters = [ 
				filter,
				twistFilter
			];
			waveFilters.push(filter);
			twistFilters.push(twistFilter);
			
			container.addChild(waveContainer);
			waves.push(wave);
			waveContainers.push(waveContainer);
		}

	}

	// private functions only accessible by the contents of the function, public or private
	function bindEvents(){
		// window.App.removeFromCallStack(scroll, 'scroll' );
		// window.App.removeFromCallStack(resize, 'resize' );

	}

	function remove() {

		// window.App.removeFromCallStack(scroll, 'scroll' );
		// window.App.removeFromCallStack(resize, 'resize' );

		el.remove();
	}
	
	function scroll() {

	}

	function _update() {

	}

	function resize() {

	}

	function drawLayersAtPosition() {

	}

	function _redraw() {
		// var increment = 0.5;
		var difX = ((Config.mouse.px / Config.w.w));
		var difY = ((Config.mouse.py / Config.w.h));
		if( Config.mouse.py < 20 ){
			difY = 0;
		}
		
		for( var w = 0; w < waveFilters.length; w++){
			
			var wave = waves[w];
			var waveFilter = waveFilters[w];
		
			waveFilter.baseamp = ((difX+difY)/2) * (0.035 * numWaves);
			waveFilter.speed = ( ((difX+difY)/2) * 1.5 );

			var time = 0.1 * ((w) * 0.03);
			var va = 2.0 * difY * (numWaves - w)/numWaves;
			var rate = 4.5 * (difY);

			// time = 0;
			// va = 0;
			// rate = 0;

			waveFilter.time += time;
			waveFilter.viewAngle = va;
			waveFilter.rate = rate;

		}
		
		// where is the bulge:

		// is there a mouse move change or entropy:

		var difBetweenFrames = Math.abs( (prevX + prevY) - (difX + difY) );
		trace( difBetweenFrames );

		for( var t = 0; t < twistFilters.length; t++ ){

			var tf = twistFilters[t];

			// tf.offset = {x: difX, y: difY };
			
			if( difBetweenFrames == 0 ){
				if( tf.strength > 0 ){
					tf.strength = tf.strength * 0.98;
				}
				
			}else{
				// tf.strength = (twistFilters.length - t) / twistFilters.length * 0.95;
				var maxStre = 0.7;// * (t) / twistFilters.length;
				if( tf.strength < maxStre ){
					tf.strength = tf.strength * 1.5;
				}
			}

			// tf.radius += ((difY) - tf.radius) * 0.999;
			// tf.radius = difY * 0.9;

			tf.center = {x: difX, y: difY };

		}


		// update color layers:
		for( var l = 0; l < waveContainers.length; l++){
			var waveContainer = waveContainers[l];

			var wave = waveContainer.children[0],
				x = 0,
				y =  l/waveContainers.length * Config.w.h,
				w = Config.w.w,
				h = Config.w.h; //Config.w.h * (1/numWaves);

			waveContainer.removeChild(wave);

			var c = l;
			if( c >= colorSteps.length ){
				c = l - colorSteps.length;
			}

			var colorGroup = colorSteps[c];

			var newWave = new PIXI.Graphics();
			newWave.beginFill( colorGroup[Math.round(colorStepsProgress)] );
			
			var newWaveContianer = plotWavePath(newWave, l, difY);

			// end the fill
			newWave.endFill();
			
			newWaveContianer.position.x = 0;
			newWaveContianer.position.y = 0;

			waveContainer.addChild(newWaveContianer);
		}

		if( (colorStepsProgress >= colorStepsMax && colorStepsDirection > 0) || (colorStepsProgress <= 0 && colorStepsDirection < 0 ) ){
			// reverse direction!
			trace(' switch direction ');
			colorStepsDirection = colorStepsDirection * -1;
		}
		colorStepsProgress += colorStepsDirection;
		

		prevY = difY;
		prevX = difX;

		renderer.render(stage);
	}

	function plotWavePath (wave, i, percent) {
		//percent: assess where in between the max and min range are we:
		//wave pixi graphic to draw beizer curve to
		
		var container = new PIXI.Container();
		var pointList = [];
		// var wave = new PIXI.Graphics();

		// first point move to:
		var ptsMin = wavesPos[i].min;
		var ptsMax = wavesPos[i].max;

		var wh = Config.w.h,
			ww = Config.w.w,
			x = mixTwo( ptsMin[0].x, ptsMax[0].x, percent),
			y = mixTwo( ptsMin[0].y, ptsMax[0].y, percent);
		
		wave.moveTo(x * ww, y * wh );

		// the last iteration of the for loop will set these variables for use after loop.
		var lastX = 0,
			lastY = 0;

		if( ptsMin.length != ptsMax.length){
			trace('point line indexes dont match BREAK! FIX IT!' + i );
			return false;
		}

		// we loop through the points drawing the top of the curve.
		for(var w = 1; w < ptsMax.length; w++ ){
			
			var ptMin = ptsMin[w],
				ptMax = ptsMax[w];

			if( Object.keys(ptMin).length == 2 ){
				// just points:

				lastX = mixTwo( ptMin.x, ptMax.x, percent );
				lastY = mixTwo( ptMin.y, ptMax.y, percent );

				wave.lineTo( 
					lastX * ww,
					lastY * wh
				);

			}else{
				
				// bezier curve
				wave.quadraticCurveTo( 
					mixTwo( ptMin.cpx, ptMax.cpx, percent ) * ww,
					mixTwo( ptMin.cpy, ptMax.cpy, percent ) * wh,
					mixTwo( ptMin.x, ptMax.x, percent ) * ww,
					mixTwo( ptMin.y, ptMax.y, percent ) * wh
				);
				

				if( showPoints ){
					//  aqua
					// var graphics = new PIXI.Graphics();
					// graphics.beginFill(0x00FFFF);

					// magenta
					var graphics2 = new PIXI.Graphics();
					graphics2.beginFill(0xFF00FF);

					graphics2.drawRect( 
						mixTwo( ptMin.cpx, ptMax.cpx, percent ) * ww - (pointSize/2),
						mixTwo( ptMin.cpy, ptMax.cpy, percent ) * wh - (pointSize/2),
						pointSize, pointSize 
					);

					graphics2.alpha = squareAlpha;
					container.addChild(graphics2);
					
				}
			}
		}

		container.addChildAt(wave, 0);

		return container;
	}

	function mixTwo(a,b,mix){
		// trace(' mix two ' + a+" - "+ " - "+b +" - "+ mix );
		return a - (mix * (a - b) );
	}

	function gradient(startColor, endColor, steps) {
         var start = {
                 'Hex'   : startColor,
                 'R'     : parseInt(startColor.slice(1,3), 16),
                 'G'     : parseInt(startColor.slice(3,5), 16),
                 'B'     : parseInt(startColor.slice(5,7), 16)
         }
         var end = {
                 'Hex'   : endColor,
                 'R'     : parseInt(endColor.slice(1,3), 16),
                 'G'     : parseInt(endColor.slice(3,5), 16),
                 'B'     : parseInt(endColor.slice(5,7), 16)
         }
         var diffR = end['R'] - start['R'],
	         diffG = end['G'] - start['G'],
	         diffB = end['B'] - start['B'],
	         stepsHex  = new Array(),
	         stepsR    = new Array(),
	         stepsG    = new Array(),
	         stepsB    = new Array();

         for(var i = 0; i <= steps; i++) {
                 stepsR[i] = start['R'] + ((diffR / steps) * i);
                 stepsG[i] = start['G'] + ((diffG / steps) * i);
                 stepsB[i] = start['B'] + ((diffB / steps) * i);
                 stepsHex[i] = '0x' + Math.round(stepsR[i]).toString(16) + '' + Math.round(stepsG[i]).toString(16) + '' + Math.round(stepsB[i]).toString(16);
         }
         return stepsHex;
     }


	// initialize
	init();

	// public functions accessible externally.
	return {
		getEl : function() {
			return el
		},

		update : function() {
			_update();
			// resize();
		},

		destory : function() {
			remove();
		},

		redraw : function() {

			_redraw();
		}
		
	}
}

module.exports = waves;




/** WEBPACK FOOTER **
 ** ./src/js/controllers/wavesBeizer.js
 **/